import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledUserImage = styled.img `
    width: 34px;
    height: auto;
    margin-right: 6px;
`;
const UserImage = ({ className, userImageUrl }) => (_jsx(StyledUserImage, { src: userImageUrl, className: className }));
export default UserImage;
